export enum Border {
    top = 'top',
    bottom = 'bottom',
    left = 'left',
    right = 'right',
    all = 'all',
    none = 'none',
}
